var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "py-2 title" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("assignment")]),
          _vm._v(" "),
          _c("div", { staticClass: "title info--text" }, [
            _vm._v("Information"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.metadataHeaders,
          "disable-initial-sort": "",
          "hide-headers": "",
          items: _vm.metadataItems,
          "hide-actions": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item, index }) {
              return [
                _c("tr", { class: { alternate: index % 2 == 0 } }, [
                  _c("td", { staticClass: "text-xs-left font-weight-medium" }, [
                    _vm._v(_vm._s(item.Field)),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(_vm._s(_vm.getMetadataValue(item))),
                  ]),
                  _vm._v(" "),
                  _vm.editForm
                    ? _c(
                        "td",
                        { staticClass: "text-xs-right" },
                        [
                          item.onEdit
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { "open-delay": 500, right: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return item.onEdit(item)
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "warning" },
                                                  },
                                                  [_vm._v("edit")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Button.Edit"))),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("EditContinuousCategoryDialog", {
        ref: "editContinuousCategoryDialog",
        attrs: { station: _vm.continuousStation },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }